import router from '@app/app-routing'
import { findIndex, isString } from 'lodash'
import { cookies } from './cookie'
import { http } from './interceptor'
import jsCookie from 'js-cookie'
import { City, defaultCity, municipalityList } from '@constant/city'

export const CITY_COOKIE = "city_service"

export function getCityId(cityId: string | number) {
  if (findIndex(municipalityList, o => o == cityId) > -1) {
    cityId = Number(cityId) + 100
  }
  return `${cityId}`
}

export async function getCityNameByCityId(cityId: string | number): Promise<string> {
  const response: any = await http.get('//address.cekid.com/addressview/GetNameById', {
    params: {
      addressId: cityId
    }
  })
  console.log(response, 'response')
  if (response && response.RetCode * 1 === 0) {
    const ro = response.Result
    return ro.NAME
  } else {
    return ''
  }
}


//chooseCityFirst是否优先取city
export async function getSelectedCity(chooseCityFirst = true): Promise<City> {
  const currentRoute = router.currentRoute
  const query = currentRoute.query
  const isSelected = (query && query.swt === '1') || chooseCityFirst
  let cityId = ''
  let cityName = ''
  // const cityIdCityName = cookies.get('city')
  const cityIdCityName = cookies.get(CITY_COOKIE)
  if (isSelected && cityIdCityName) {
    if (isString(cityIdCityName)) {
      const iNList = cityIdCityName.split('_')
      cityId = iNList[0]
      cityName = decodeURIComponent(iNList[1])
      if (cityId && !cityName) {
        cityName = await getCityNameByCityId(cityId)
      }
      cityName = cityName.replace('市', '')
    }
  } else {
    cityId = cookies.get('citycode') || ''
    if (cityId) {
      cityName = await getCityNameByCityId(cityId)
    }
    cityName = cityName.replace('市', '')
  }
  if (cityId && cityName) {
    cityId = getCityId(cityId)
    return {
      cityId,
      cityName
    }
  } else {
    return defaultCity
  }
}

//chooseCityFirst是否优先取city  为了兼容之前的页面
export function getSelectedCityId(chooseCityFirst=true): string | number {
  const currentRoute = router.currentRoute
  const query = currentRoute.query
  const isSelected = (query && query.swt === '1') || chooseCityFirst
  let cityId = ''
  // const cityIdCityName = cookies.get('city')
  const cityIdCityName = cookies.get(CITY_COOKIE)
  if (isSelected && cityIdCityName) {
    if (isString(cityIdCityName)) {
      const iNList = cityIdCityName.split('_')
      cityId = iNList[0]
    }
  } else {
    cityId = cookies.get('citycode') || ''
  }
  cityId = getCityId(cityId)
  return cityId || defaultCity.cityId || ''
}

// 获取最后一次在H5中选择的城市
export function getSetCityServiceInH5() {
  const setInH5 = jsCookie.get('city_service_set_in_h5') || ''
  const setCity = setInH5.split('_')[0]
  const setTime = setInH5.split('_')[1]
  return {
    setCity,
    setTime,
  }
}

export function setSelectedCity(citycode: string, cityName: string, url: string): void {
  // cookies.set方法默认添加了过期属性导致iOS设备无法修改
  // jsCookie.set('city', `${citycode}_${cityName}`, { domain: '.cekid.com' })
  jsCookie.set(CITY_COOKIE, `${citycode}_${cityName}`, { domain: '.cekid.com' })
  // 保存一下最后一次在H5中设置的城市，和APP设置的区分一下
  jsCookie.set('city_service_set_in_h5', `${citycode}_${Date.now()}_${cityName}`, { domain: '.cekid.com' })
}